<template>
  <div class="kvComment">
    <el-breadcrumb class="bread-nav" separator="/">
      <el-breadcrumb-item>首页</el-breadcrumb-item>
      <el-breadcrumb-item>KV直播</el-breadcrumb-item>
      <el-breadcrumb-item>评论管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="commentLeft">
      <el-select v-model="creator" clearable placeholder="请选择执行（非必选）" @change="changeCreator()">
        <el-option v-for="item in userList" :label="item.userName" :key="item.userId" :value="item.userId"></el-option>
      </el-select>
      <el-select v-model="liveValue" clearable placeholder="请选择直播" @change="changeLive(liveValue)">
        <el-option v-for="item in filterCreator" :label="item.liveTitle" :key="item.id" :value="item.id"></el-option>
      </el-select>
    </div>
    <div class="commentRight">
      <ul class="commentList">
        <li v-for="(item, index) in liveCommentList" :key="item.id">
          <div class="commentText">{{item.content}}</div>
          <div class="commentTime">{{item.createTime}}
            <el-button type="danger" size="mini" icon="delete" @click="deleteComment(item, index)"></el-button>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import CONFIG from "@/config/index.js";
  import TOOL from '@/tool/index.js';
  import router from "@/router/index.js";
  import { mapGetters } from 'vuex';
  import co from 'co';
  export default {
    name: "kvliveComment",
    data() {
      return {
        creator:'',
        liveValue:'',
        userList:null,
        liveList:null,
        liveCommentList:[]
      }
    },
    computed: {
      filterCreator(){
        let creator = this.creator;
        let value = this.liveList;
        if(typeof creator!=='number'){
          return value;
        }else{
          return value.filter(function(item){
              return creator === item.creator;
          });
        }
      }
    },
    methods: {
      //删除评论
      deleteComment(item, index){
        console.log(index);
        this.$http.delete(CONFIG.HOST + "/live/comment/deleteComment/"+item.id).then((response)=>{
          let result = response.body;
          if (result && result.status === 1) {
            this.deleteArrayByIndex(this.liveCommentList,index);
            this.$notify.success({
              message: "删除评论成功"
            });
          } else {
            this.$notify.error({
              message: result.message
            });
          }
        }, (response)=>{
          console.log(response);
        });
      },
      //删除数组某个索引下的元素
      deleteArrayByIndex(arr,index){
        arr.splice(index,1);
        return arr;
      },
      //改变执行时触发
      changeCreator(){
        this.liveValue = '';
      },
      //改变直播时执行触发
      changeLive(liveValue){
        if(typeof liveValue!=='number'){
          this.liveCommentList = [];
          return ;
        }
        this.$http.get(CONFIG.HOST + "/live/comment/listComment/"+liveValue).then((response)=>{
          let result = response.body;
          if (result && result.status === 1) {
            this.liveCommentList = result.data;
          } else {
            this.$notify.error({
              message: result.message
            });
          }
        }, (response)=>{
          console.log(response);
        });
      },
      _init(){
        //获取执行人员列表
        this.$http.get(CONFIG.HOST + "/users/list").then((response)=>{
          let result = response.body;
          if (result && result.status === 1) {
            this.userList = result.data.filter(function(item){
                let reg = /^执行/;
                return reg.test(item.permissionsName);
            });
          } else {
            this.$notify.error({
              message: result.message
            });
          }
        }, (response)=>{
          console.log(response);
        });
        //获取所有开启评论的直播
        this.$http.get(CONFIG.HOST + "/live/listOpenCommentLive").then((response)=>{
          let result = response.body;
          if (result && result.status === 1) {
            this.liveList = result.data;
          } else {
            this.$notify.error({
              message: result.message
            });
          }
        }, (response)=>{
          console.log(response);
        });
      }
    },
    mounted(){
      this._init();
    }
  };
</script>
<style lang="less">
  .kvComment{
    width: 90%;
    height: 80%;
    min-height: 550px;
    margin-top: 0;
    margin-left: 10px;
    position: absolute;
    overflow: auto;
    .bread-nav{
      margin: 20px 0;
    }
    .commentLeft{
      width: 30%;
      height: 85%;
      position: absolute;
      left: 0;
      top:15%;
      text-align: left;
      border-right:1px #efefef solid;
      .el-select{
        width: 90%;
        margin-bottom: 20px;
        margin-left: 5%;
      }
    }
    .commentRight{
      width: 60%;
      height: 84%;
      position: absolute;
      left: 32%;
      top:15%;
      overflow: hidden;
      ul,ol,li {
        list-style-type: none;
      }
      .commentList{
        width: 100%;
        height: 100%;
        overflow: auto;
        li{
          width: 90%;
          position: relative;
          border:1px #C0CCDA solid;
          margin: 0 auto;
          margin-bottom: 8px;
          text-align: left;
          .commentText{
            width: 90%;
            font-size: 14px;
            line-height: 20px;
          }
          .commentTime{
            width: 90%;
            font-size: 13px;
            height: 20px;
            color: #99A9BF;
          }
          .el-button{
            height: 24px;
            width: 24px;
            position: absolute;
            top:50%;
            margin-top: -12px;
            right: 10px;
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// Comment.vue?5b2187c3